import { useQuery } from "@tanstack/react-query";
import { getSuperAdminUsers } from "../action/getSuperAdminUsers";
import { SUPER_ADMIN_USERS_QUERY_KEY, SuperAdminUsersResult } from "../interfaces";

interface UseSuperAdminUsersQueryParams {
  page?: number;
  pageSize?: number;
  search?: string;
  role?: string;
  confirmationStatus?: string;
  recordType?: string;
}

export const useSuperAdminUsersQuery = ({
  page = 1,
  pageSize = 20,
  search = "",
  role = "all",
  confirmationStatus = "all",
  recordType = "all",
}: UseSuperAdminUsersQueryParams = {}) => {
  return useQuery<SuperAdminUsersResult>({
    queryKey: [...SUPER_ADMIN_USERS_QUERY_KEY, page, pageSize, search, role, confirmationStatus, recordType],
    queryFn: () =>
      getSuperAdminUsers({
        page,
        pageSize,
        search,
        role,
        confirmationStatus,
        recordType,
      }),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 1,
  });
};
